module.exports = __webpack_public_path__ + "img/album18_07.3bd171b2.jpg";